import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { Viewerlayer } from "../../../model/viewerlayer";
import { BaseDualViewerComponent } from "../base-viewer/base-dual-viewer.component";
import { DialogGalleryComponent } from "../../../../dialog-components/image-gallery/dialog-gallery/dialog-gallery.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-phoenix-viewer",
  templateUrl: "./phoenix-viewer.component.html",
  styleUrls: ["./phoenix-viewer.component.scss"],
  standalone: false,
})
export class PhoenixViewerComponent extends BaseDualViewerComponent implements OnDestroy, AfterViewInit {
  dualView = false;

  disabledMap = false;

  openImageGalleryDialog(mapCenter: number[] | string[], images: any[], location: string): void {
    localStorage.setItem("zoom", `${this.mapService.getCoreMap().getZoom()}`);
    localStorage.setItem("extent", this.mapService.getCoreMap().getExtent());
    localStorage.setItem("mapCenter", mapCenter.join(","));
    this.dialog.open(DialogGalleryComponent, {
      width: "80%",
      height: "75%",
      panelClass: "gallery-dialog",
      disableClose: true,
      data: {
        location,
        images,
        viewerService: this.viewerService,
        galleryService: this.galleryService,
        extent: localStorage
          .getItem("extent")
          .split(",")
          .map((elem) => +elem),
      },
    });
  }

  /**
   * Configure map options and features
   * @param settings
   */
  configureMapOptions(settings: any) {
    super.configureMapOptions(settings);
    this.enableContextMenu();
  }

  getLayersToSaveConfiguration(): Viewerlayer[] {
    return this.viewerService.getCollections().concat(this.viewerService.getOverlayLayers());
  }

  customOptions(): any {
    return {};
  }

  loadLayers(layers: any[]): void {
    this.loadCommonLayers(layers);
  }
}
